
export default {
  layout: "blank",
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: "168px"
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    }
  }
};
